import * as React from 'react';
import { SetSidebarStateContext, SidebarStateContext } from './contexts';
import type { SetSidebarStateContextType } from './contexts';

type Props = {
  children?: React.ReactNode
};

function SidebarStateProvider(
  {
    children,
  }: Props,
): React.ReactElement {
  const [sidebarState, setSidebarState] = React.useState(false);

  const setSidebarStateContextValue = React.useMemo((): SetSidebarStateContextType => ({
    setSidebarState,
    openSidebar: setSidebarState.bind(undefined, true),
    closeSidebar: setSidebarState.bind(undefined, false),
  }), []);

  return (
    <SidebarStateContext.Provider value={sidebarState}>
      <SetSidebarStateContext.Provider value={setSidebarStateContextValue}>
        {children}
      </SetSidebarStateContext.Provider>
    </SidebarStateContext.Provider>
  );
}

SidebarStateProvider.defaultProps = {
  children: undefined,
};

export default React.memo<Props>(SidebarStateProvider);
